<template>
  <section class="popular-grid">
    <div class="container">
      <div class="popular-grid__header">
        <h2 class="popular-grid__title">{{ title }}</h2>
        <p class="popular-grid__subtitle">{{ subtitle }}</p>
        <p class="popular-grid__desc">{{ desc }}</p>
      </div>

      <div class="popular-grid__pills">
        <NuxtLink
          v-for="item in items"
          :key="item.slug"
          :to="`${basePath}${item.slug}`"
          class="popular-grid__pill">
          {{ item.label }}
        </NuxtLink>
      </div>
    </div>
  </section>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    default: '',
  },
  desc: {
    type: String,
    default: '',
  },
  items: {
    type: Array,
    default: () => [],
  },
  basePath: {
    type: String,
    default: '/',
  },
})
</script>

<style scoped>
.popular-grid {
  background: var(--bg-base);
  padding-block: var(--space-16);
  border-top: 1px solid var(--border-subtle);
}

.popular-grid__header {
  text-align: center;
  margin-bottom: var(--space-10);
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.popular-grid__title {
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: var(--tracking-tight);
}

.popular-grid__subtitle {
  font-size: var(--text-base);
  color: var(--text-secondary);
}

.popular-grid__desc {
  font-size: var(--text-base);
  color: var(--text-secondary);
  line-height: var(--leading-relaxed);
  max-width: 640px;
  margin-inline: auto;
}

/* Grille de pills */
.popular-grid__pills {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-3);
}

.popular-grid__pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  min-width: min(100%, 9rem);
  max-width: 100%;
  padding: 0.6em 1em;
  background: var(--bg-elevated);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  font-size: var(--text-sm);
  line-height: var(--leading-snug);
  color: var(--text-secondary);
  text-decoration: none;
  text-align: center;
  white-space: nowrap;
  transition:
    border-color var(--duration-fast) var(--ease-out),
    color var(--duration-fast) var(--ease-out),
    background var(--duration-fast) var(--ease-out);
}

.popular-grid__pill:hover {
  border-color: var(--border-default);
  color: var(--text-primary);
  background: var(--bg-surface);
}

/* Responsive */
@media (max-width: 640px) {
  .popular-grid__pill {
    white-space: normal;
    overflow-wrap: break-word;
  }

  .popular-grid__title {
    font-size: 1.5rem;
  }
}
</style>
